export default __webpack_public_path__ + "static/media/twitter.6658afa1.svg";